'use strict';

var leaflet = require('./leaflet');

require('./mapbox');

module.exports = leaflet;



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox.js/src/index.js
 ** module id = 934
 ** module chunks = 0 1 3 4 5 6
 **/